function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import React, { useState, useEffect, useLayoutEffect } from "react";
import PropTypes from "prop-types";
import useTheme from "../hooks/useTheme";
import useWindow from "../hooks/useWindow";
import { BreakpointContext } from "../hooks/useBreakpoint";
import { jsx as ___EmotionJSX } from "@emotion/core";

function BreakpointProvider(props) {
  var children = props.children;
  var theme = useTheme();
  var windowObj = useWindow();

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      mediaQueryListMap = _useState2[0],
      setMediaQueryListMap = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      breakpoint = _useState4[0],
      setBreakpoint = _useState4[1];

  useLayoutEffect(function () {
    if (!windowObj.matchMedia) {
      return;
    }

    var mediaQueryListMap = {};

    for (var bp in theme.exclusiveMediaQueries) {
      mediaQueryListMap[bp] = windowObj.matchMedia(theme.exclusiveMediaQueries[bp]);

      if (mediaQueryListMap[bp].matches) {
        setBreakpoint(bp);
      }
    }

    setMediaQueryListMap(mediaQueryListMap);
  }, [windowObj, theme.exclusiveMediaQueries]);
  useEffect(function () {
    var mounted = true;
    var removeListeners = [];

    var _loop = function _loop(bp) {
      var mediaQueryList = mediaQueryListMap[bp]; // eslint-disable-next-line no-loop-func

      var listener = function listener(event) {
        if (event.matches && mounted) {
          setBreakpoint(bp);
        }
      };

      mediaQueryList.addListener(listener);
      removeListeners.push(function () {
        mediaQueryList.removeListener(listener);
      });
    };

    for (var bp in mediaQueryListMap) {
      _loop(bp);
    }

    return function () {
      mounted = false;
      removeListeners.forEach(function (fn) {
        fn();
      });
    };
  }, [mediaQueryListMap]);
  return ___EmotionJSX(BreakpointContext.Provider, {
    value: breakpoint
  }, children);
}

BreakpointProvider.propTypes = {
  children: PropTypes.node.isRequired
};
export default BreakpointProvider;